<template>
  <!-- 学习大数据 -->
  <div class="body" v-loading="loading">
    <div class="top">
      <img
        style="width: 100%; height: 100%"
        src="https://appfile2.sbgw.cn/hhsbzhxt/7588f8ef921f4167b651ea0aeb613fcf.png"
        alt="标题背景图"
      />
      <span class="top-left">
        <img class="weather_img" :src="getImageSrc(weatherType)" alt="天气小图标"/>
        <span class="weather_text">{{ weatherType }}</span>
        <span style="padding-left: 8px">{{ temperature }}</span>
        <span style="padding-left: 32px">{{ currentDate }}</span>
        <span style="padding-left: 8px">{{ currentTime }}</span>
      </span>
      <span class="top-right">
        <img
          class="msg_img"
          src="https://appfile2.sbgw.cn/hhsbzhxt/3df0c815489c4331ba552583596ae224.png"
          alt="今日寄语图"
        />
        <span>今日寄语:</span>
        <div class="top-right-content-wrapper">
          <div class="top-right-content">
            <span v-for="(item, index) in todayMessage" :key="index">{{ item }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </div>
        </div>
      </span>
    </div>
    <!-- 8.26需求加：学员个人学习报告查看路径 -->
    <div class="report-path">个人学习报告查看路径：学员中心 > 我的页面 > 学习报告</div>
    <div class="content">
      <div class="content-left">
        <div class="card attendance attendance-card">
          <div class="card-title">
            <span>出勤</span>
            <div class="card-title-right" style="width: 160px; height: 20px">
              <span style="display: flex; align-items: center;">校出勤率<span class="number">{{schoolAttendanceRate}}%</span></span>
              <el-progress
                :percentage="schoolAttendanceRate"
                status="warning"
                :show-text="false"
              />
            </div>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/66fd6623a7c14fa991ec2e681bd371af.png"
            alt="card分割线"
          />
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: -15px;
            "
          >
            <div class="attendance-left mr-15">
              <div class="table-title-container">
                <span class="table-title title">班级出勤率排名</span>
                <div class="carousel-indicators">
                  <div
                    v-for="(_, index) in attendanceRateList"
                    :key="index"
                    class="indicator"
                    :class="{
                      active:
                        carouselStates.attendance.currentIndex.value === index,
                    }"
                    @click="() => setCarouselActivePage('attendance', index)"
                  ></div>
                </div>
              </div>
              <div class="table-content">
                <dl class="table-header">
                  <dt class="rank-column">排名</dt>
                  <dt class="class-column">班级名称</dt>
                  <dt class="attendance-rate-column">出勤率</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    :ref="(el) => (carouselStates.attendance.ref.value = el)"
                    style="height: 15vh"
                    v-if="attendanceRateList.length > 0"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="true"
                    :interval="5000"
                    @change="
                      (index) => handleCarouselChange('attendance', index)
                    "
                  >
                    <el-carousel-item
                      v-for="(itm, i) in attendanceRateList"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                      >
                        <dt class="rank-column">{{ item.sort }}</dt>
                        <dt class="class-column">{{ item.className }}</dt>
                        <dt class="attendance-rate-column">
                          {{ item.attendanceRate.toFixed(2) }}%
                        </dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else>
                    <dl
                      v-for="(itm,i) in 5"
                      :class="[
                        'table-row',
                        i % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    >
                      <dt class="rank-column"></dt>
                      <dt class="class-column"></dt>
                      <dt class="attendance-rate-column">
                      </dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div class="attendance-right">
              <div class="table-title-container">
                <span class="table-title">班级早到人数排名</span>
                <div class="carousel-indicators">
                  <div
                    v-for="(_, index) in earlyArrivalList"
                    :key="index"
                    class="indicator"
                    :class="{
                      active:
                        carouselStates.earlyArrival.currentIndex.value ===
                        index,
                    }"
                    @click="() => setCarouselActivePage('earlyArrival', index)"
                  ></div>
                </div>
              </div>
              <div class="table-content">
                <dl class="table-header">
                  <dt class="rank-column">排名</dt>
                  <dt class="class-column">班级名称</dt>
                  <dt class="count-column">早到总人数</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    :ref="(el) => (carouselStates.earlyArrival.ref.value = el)"
                    style="height: 15vh"
                    v-if="earlyArrivalList.length > 0"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="true"
                    :interval="5000"
                    @change="
                      (index) => handleCarouselChange('earlyArrival', index)
                    "
                  >
                    <el-carousel-item
                      v-for="(itm, i) in earlyArrivalList"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                      >
                        <dt class="rank-column">{{ item.sort }}</dt>
                        <dt class="class-column">{{ item.className }}</dt>
                        <dt class="count-column">{{ item.count }}人</dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else >
                    <dl
                    v-for="(itm,i) in 5"
                      :class="[
                        'table-row',
                        i % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    >
                      <dt class="rank-column"></dt>
                      <dt class="class-column"></dt>
                      <dt class="attendance-rate-column">
                      </dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="attendance-rate">
            <span class="chart-title"><span>全校周出勤率趋势图</span></span>
            <div ref="attendanceChartRef" class="chart-container"></div>
          </div>
        </div>
        <div class="card offline-examination">
          <div class="card-title">
            <span>学习阶段考试</span>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/9378ad7ea46c45f29eba56879863de91.png"
            alt="card分割线"
          />
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-top: -15px;
              height: 89%;
            "
          >
            <div class="offline-examination-left mr-5">
              <div class="table-title-container">
                <div class="title-text">{{ currentYearExams[currentExamIndex]?.title || '' }}</div>
                <div class="carousel-indicators">
                  <div
                    v-for="(_, index) in currentYearExams"
                    :key="index"
                    class="indicator"
                    :class="{ active: currentExamIndex === index }"
                    @click="handleExamDotClick(index)"
                  ></div>
                </div>
              </div>
              <div class="table-content">
                <dl class="table-header">
                  <dt class="rank-column">排名</dt>
                  <dt class="class-column">班级名称</dt>
                  <dt class="score-column">平均分</dt>
                </dl>
                <div class="carousel-container">
                  <el-carousel
                    ref="examCarouselRef"
                    style="height: 27vh"
                    v-if="examClassRankList[currentExamIndex]?.length"
                    arrow="never"
                    indicator-position="none"
                    direction="vertical"
                    :autoplay="false"
                    :interval="5000"
                    @change="handleExamCarouselChange"
                  >
                    <el-carousel-item
                      v-for="(itm, i) in examClassRankList[currentExamIndex]"
                      :key="i"
                    >
                      <dl
                        v-for="(item, index) in itm"
                        :key="index"
                        :class="['table-row', index % 2 !== 0 ? 'columns-style' : '']"
                      >
                        <dt class="rank-column">{{ item.sort }}</dt>
                        <dt class="class-column">{{ item.gradeName }}</dt>
                        <dt class="score-column">{{ item.averageScore }}</dt>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                  <div v-else>
                    <dl
                      v-for="(item, index) in 9"
                      :key="index"
                      :class="['table-row', index % 2 !== 0 ? 'columns-style' : '']"
                    >
                      <dt class="rank-column"></dt>
                      <dt class="class-column"></dt>
                      <dt class="score-column"></dt>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div class="offline-examination-right">
              <div class="title" style="width: 100%; text-align: center">
                全校线下考试平均分趋势图
              </div>
              <div
                ref="offlineExamInationChartRef"
                class="chart-container"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-Middle">
        <div class="card integral integral-card">
          <div class="card-title">
            <span>学习积分</span>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/faddfa53ab564c2fb62f9dfc1fbc0c17.png"
            alt="card分割线"
          />
          <div class="integral-content">
            <div class="pie-chart">
              <span class="chart-title">全校积分构成占比</span>
              <div
                ref="schoolIntegralPieChartRef"
                class="chart-container"
                style="height: 21vh"
              ></div>
            </div>
            <div class="trend-chart">
              <span class="chart-title">全校积分60天趋势图</span>
              <div
                ref="schoolIntegralTrendChartRef"
                class="chart-container"
              ></div>
            </div>
            <div class="class-points">
              <div class="table-title-container">
                <span class="title">班级小组积分排名</span>
                <div class="carousel-indicators">
                  <div
                    v-for="(_, index) in classGroupIntegralListTop"
                    :key="index"
                    class="indicator"
                    :class="{
                      active:
                        carouselStates.integral.currentIndex.value === index,
                    }"
                    @click="() => setCarouselActivePage('integral', index)"
                  >
                  </div>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between">
                <div
                  class="class-points-left"
                >
                  <span class="calss-title">{{
                    classGroupIntegralListTop[integralIndex]?.className || '[2026专升本]慧•上岸全程班'
                  }}</span>
                  <div class="table-content">
                    <dl class="table-header">
                      <dt class="rank-column">排名</dt>
                      <dt class="class-column">小组名称</dt>
                      <dt class="rate-column">积分总数</dt>
                    </dl>
                    <el-carousel
                      :ref="(el) => (carouselStates.integral.ref1.value = el)"
                      style="height: 12vh"
                      v-if="classGroupIntegralListTop.length > 0"
                      arrow="never"
                      indicator-position="none"
                      direction="vertical"
                      :autoplay="true"
                      :interval="5000"
                      @change="
                        (index) => handleCarouselChange('integral', index)
                      "
                    >
                      <el-carousel-item
                        v-for="(itm, i) in classGroupIntegralListTop"
                        :key="i"
                      >
                        <div v-if="itm.groupList.length > 0">
                          <dl
                            v-for="(item, index) in itm.groupList"
                            :key="index"
                            :class="[
                              'table-row',
                              index % 2 !== 0 ? 'columns-style' : '',
                            ]"
                          >
                            <dt class="rank-column">{{ item.sort }}</dt>
                            <dt class="class-column" style="padding-right: 0; ">{{ item.groupName }}</dt>
                            <dt class="rate-column">{{ item.totalIntegra }}</dt>
                          </dl>
                        </div>
                        <div v-else>
                          <dl
                            v-for="(item, index) in 4"
                            :key="index"
                            :class="[
                              'table-row',
                              index % 2 !== 0 ? 'columns-style' : '',
                            ]"
                          >
                            <dt class="rank-column"></dt>
                            <dt class="class-column"></dt>
                            <dt class="rate-column"></dt>
                          </dl>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                    <div v-else>
                      <dl
                        v-for="(item, index) in 4"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                      >
                        <dt class="rank-column"></dt>
                        <dt class="class-column"></dt>
                        <dt class="rate-column"></dt>
                      </dl>
                    </div>
                  </div>
                </div>
                <div class="class-points-right">
                  <!-- 班级积分占比 -->
                  <span class="calss-title" style="text-align: center"
                    >{{
                      classGroupIntegralListTop[integralIndex]?.className || '[2026专升本]慧•上岸全程班'
                    }}积分占比</span
                  >
                  <div
                    ref="classIntegralPieChartRef1"
                    class="chart-container"
                  ></div>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between">
                <div
                  class="class-points-left"
                >
                  <span class="calss-title">{{
                    classGroupIntegralListBottom[integralIndex]?.className || '[2026专升本]慧•上岸全程班'
                  }}</span>
                  <div class="table-content">
                    <dl class="table-header">
                      <dt class="rank-column">排名</dt>
                      <dt class="class-column">小组名称</dt>
                      <dt class="rate-column">积分总数</dt>
                    </dl>
                    <el-carousel
                      :ref="(el) => (carouselStates.integral.ref2.value = el)"
                      style="height: 12vh"
                      v-if="classGroupIntegralListBottom.length > 0"
                      arrow="never"
                      indicator-position="none"
                      direction="vertical"
                      :autoplay="true"
                      :interval="5000"
                      @change="
                        (index) => handleCarouselChange('integral', index)
                      "
                    >
                      <el-carousel-item
                        v-for="(itm, i) in classGroupIntegralListBottom"
                        :key="i"
                      > 
                      <div v-if="itm.groupList.length > 0">
                        <dl
                          v-for="(item, index) in itm.groupList"
                          :key="index"
                          :class="[
                            'table-row',
                            index % 2 !== 0 ? 'columns-style' : '',
                          ]"
                        >
                          <dt class="rank-column">{{ item.sort }}</dt>
                          <dt class="class-column" style="padding-right: 0; ">{{ item.groupName }}</dt>
                          <dt class="rate-column">{{ item.totalIntegra }}</dt>
                        </dl>
                        </div>
                        <div v-else>
                          <dl
                            v-for="(item, index) in 4"
                            :key="index"
                            :class="[
                              'table-row',
                              index % 2 !== 0 ? 'columns-style' : '',
                            ]"
                          >
                            <dt class="rank-column"></dt>
                            <dt class="class-column"></dt>
                            <dt class="rate-column"></dt>
                          </dl>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                    <div v-else>
                      <dl
                        v-for="(item, index) in 4"
                        :key="index"
                        :class="[
                          'table-row',
                          index % 2 !== 0 ? 'columns-style' : '',
                        ]"
                      >
                        <dt class="rank-column"></dt>
                        <dt class="class-column"></dt>
                        <dt class="rate-column"></dt>
                      </dl>
                    </div>
                  </div>
                </div>
                <div class="class-points-right">
                  <!-- 班级积分占比 -->
                  <span class="calss-title" style="text-align: center"
                    >{{
                      classGroupIntegralListBottom[integralIndex]?.className || '[2026专升本]慧•上岸全程班'
                    }}积分占比</span
                  >
                  <div
                    ref="classIntegralPieChartRef2"
                    class="chart-container"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="content-right-top">
          <div 
            class="content-right-top-item mr-16 hand" 
            :class="{ active: activeYear === '26届' }"
            @click="activeYear = '26届'"
          >
            26届
          </div>
          <div 
            class="content-right-top-item hand" 
            :class="{ active: activeYear === '25届' }"
            @click="activeYear = '25届'"
          >
            25届
          </div>
        </div>
        <div class="card work-card">
          <div class="card-title">
            <span>作业</span>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/5ec0fd0ae5b64bd39841e0a47ff8d174.png"
            alt="card分割线"
          />
          <div class="homework-submit-data">
            <div class="table-title-container">
              <span class="title">班级最近一次作业提交数据</span>
              <div class="carousel-indicators">
                <div
                  v-for="(_, index) in homeworkSubmitData"
                  :key="index"
                  class="indicator"
                  :class="{
                    active:
                      carouselStates.homework.currentIndex.value === index,
                  }"
                  @click="() => setCarouselActivePage('homework', index)"
                ></div>
              </div>
            </div>
            <div class="table-content">
              <dl class="table-header1">
                <dt class="class-column1">班级名称</dt>
                <dt class="rate-column mr-15">提交率</dt>
                <dt class="score-column mr-15">平均分率</dt>
                <dt class="score-column">最高分率</dt>
                <dt class="number-of-excess-column mr-15">超均分人数</dt>
                <dt class="number-of-excess-column">未交作业人数</dt>
              </dl>
              <div class="carousel-container">
                <el-carousel
                  :ref="(el) => (carouselStates.homework.ref.value = el)"
                  style="height: 24vh"
                  v-if="homeworkSubmitData.length > 0"
                  arrow="never"
                  indicator-position="none"
                  direction="vertical"
                  :autoplay="true"
                  :interval="5000"
                  @change="(index) => handleCarouselChange('homework', index)"
                >
                  <el-carousel-item
                    v-for="(itm, i) in homeworkSubmitData"
                    :key="i"
                  >
                    <dl
                      v-for="(item, index) in itm"
                      :key="index"
                      :class="[
                        'table-row1',
                        index % 2 !== 0 ? 'columns-style' : '',
                      ]"
                    >
                      <dt class="class-column">{{ item.gradeName }}</dt>
                      <dt class="rate-column mr-15">{{ item.submitRate }}%</dt>
                      <dt class="score-column mr-15">{{ item.averageScoreRate }}%</dt>
                      <dt class="score-column">{{ item.maxRate }}%</dt>
                      <dt class="number-of-excess-column mr-15">
                        {{ item.aboveAverageCount }}
                      </dt>
                      <dt class="number-of-excess-column">
                        {{ item.unsubmittedCount }}
                      </dt>
                    </dl>
                  </el-carousel-item>
                </el-carousel>
                <div v-else>
                  <dl
                    v-for="(item, index) in 8"
                    :key="index"
                    :class="[
                      'table-row',
                      index % 2 !== 0 ? 'columns-style' : '',
                    ]"
                  >
                    <dt class="class-column"></dt>
                    <dt class="rate-column"></dt>
                    <dt class="score-column"></dt>
                    <dt class="score-column"></dt>
                    <dt class="number-of-excess-column"></dt>
                    <dt class="number-of-excess-column"></dt>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card word-card">
          <div class="card-title">
            <span>单词学习</span>
            <div class="subtitle">
              <span class="subtitle-title">《{{ wordBook || '暂无书籍名称'}}》</span>
              <span class="subtitle-text">全校学习单词最多书籍</span>
            </div>
          </div>
          <img
            class="segmentation"
            src="https://appfile2.sbgw.cn/hhsbzhxt/66fd6623a7c14fa991ec2e681bd371af.png"
            alt="card分割线"
          />
          <div class="word-learning-content">
            <div class="word-learning-top">
              <div class="word-learning-rankings mr-15">
                <div class="rank-section">
                  <div class="table-title-container">
                    <span class="section-title title"
                      >班级学习单词数量排名</span
                    >
                    <div class="carousel-indicators" style="margin-top: -8px;">
                      <div
                        v-for="(_, index) in wordLearningRankData"
                        :key="index"
                        class="indicator"
                        :class="{
                          active:
                            carouselStates.wordLearning.currentIndex.value ===
                            index,
                        }"
                        @click="
                          () => setCarouselActivePage('wordLearning', index)
                        "
                      ></div>
                    </div>
                  </div>
                  <div class="table-content" style="margin-top: -8px;">
                    <dl class="table-header">
                      <dt class="rank-column">排名</dt>
                      <dt class="class-column">班级名称</dt>
                      <dt class="count-column">单词总数</dt>
                    </dl>
                    <div class="carousel-container">
                      <el-carousel
                        :ref="
                          (el) => (carouselStates.wordLearning.ref.value = el)
                        "
                        style="height: 15vh"
                        v-if="wordLearningRankData.length > 0"
                        arrow="never"
                        indicator-position="none"
                        direction="vertical"
                        :autoplay="true"
                        :interval="5000"
                        @change="
                          (index) => handleCarouselChange('wordLearning', index)
                        "
                      >
                        <el-carousel-item
                          v-for="(itm, i) in wordLearningRankData"
                          :key="i"
                        >
                          <dl
                            v-for="(item, index) in itm"
                            :key="index"
                            :class="[
                              'table-row',
                              index % 2 !== 0 ? 'columns-style' : '',
                            ]"
                          >
                            <dt class="rank-column">{{ item.sort }}</dt>
                            <dt class="class-column">{{ item.gradeName }}</dt>
                            <dt class="count-column">{{ item.totalWordCount }}</dt>
                          </dl>
                        </el-carousel-item>
                      </el-carousel>
                      <div v-else>
                        <dl
                          v-for="(item, index) in 5"
                          :key="index"
                          :class="[
                            'table-row',
                            index % 2 !== 0 ? 'columns-style' : '',
                          ]"
                        >
                          <dt class="rank-column"></dt>
                          <dt class="class-column"></dt>
                          <dt class="count-column"></dt>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="word-learning-trend">
                <div
                  class="section-title"
                  style="width: 100%; text-align: center"
                >
                  全校单词学习趋势图
                </div>
                <div ref="wordLearningChartRef" class="chart-container" style="margin-top:-2px;height:17.6vh"></div>
              </div>
            </div>
            <div class="word-learning-bottom">
              <div class="rank-section">
                <div class="table-title-container">
                  <span class="section-title title">单词日常练习</span>
                  <div class="carousel-indicators">
                    <div
                      v-for="(_, index) in pkRankData"
                      :key="index"
                      class="indicator"
                      :class="{
                        active:
                          carouselStates.pkRank.currentIndex.value === index,
                      }"
                      @click="() => setCarouselActivePage('pkRank', index)"
                    ></div>
                  </div>
                </div>
                <div class="table-content" style="margin-top: -8px;">
                  <dl class="table-header">
                    <dt class="rank-column">排名</dt>
                    <dt class="class-column">班级名称</dt>
                    <dt class="count-column1">检测总数</dt>
                    <dt class="count-column1">完成率</dt>
                    <dt class="count-column1">正确率</dt>
                  </dl>
                  <div class="carousel-container">
                    <el-carousel
                      :ref="(el) => (carouselStates.pkRank.ref.value = el)"
                      style="height: 15vh"
                      v-if="pkRankData.length > 0"
                      arrow="never"
                      indicator-position="none"
                      direction="vertical"
                      :autoplay="true"
                      :interval="5000"
                      @change="(index) => handleCarouselChange('pkRank', index)"
                    >
                      <el-carousel-item v-for="(itm, i) in pkRankData" :key="i">
                        <dl
                          v-for="(item, index) in itm"
                          :key="index"
                          :class="[
                            'table-row',
                            index % 2 !== 0 ? 'columns-style' : '',
                          ]"
                        >
                          <dt class="rank-column">{{ item.sort }}</dt>
                          <dt class="class-column">{{ item.gradeName }}</dt>
                          <dt class="count-column1">{{ item.totalWordCount }}</dt>
                          <dt class="count-column1">{{ item.completeRate }}%</dt>
                          <dt class="count-column1">{{ item.accuracyRate }}%</dt>
                        </dl>
                      </el-carousel-item>
                    </el-carousel>
                    <div v-else>
                      <dl
                          v-for="(item, index) in 5"
                          :key="index"
                          :class="[
                            'table-row',
                            index % 2 !== 0 ? 'columns-style' : '',
                          ]"
                        >
                          <dt class="rank-column"></dt>
                          <dt class="class-column"></dt>
                          <dt class="count-column1"></dt>
                          <dt class="count-column1"></dt>
                          <dt class="count-column1"></dt>
                        </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted ,reactive, watch, watchEffect, nextTick, getCurrentInstance } from "vue";
import * as echarts from "echarts";
import { transform } from "lodash";
import $ from "jquery";
import { 
  GetLatestWorkStatistics, 
  GetIntegralStatistics, 
  GetAttendanceStatistics, 
  GetWeatherMessage, 
  GetOfflineExaminationAverageScores, 
  GetGradeStudyRankAsync, 
  GetPracticeStatistics, 
  GetNowYearGradeIds
} from '../network/learnBigData';
import { timeFormatNew } from "@/common/utils";

// 获取当前实例来访问路由
const { proxy } = getCurrentInstance();

// 获取地址栏时间参数的方法
const getUrlTimeParam = () => {
  // 优先从 Vue Router 获取参数（支持 hash 模式）
  let timeParam = proxy.$route.query.time;
  
  // 如果 Router 中没有，尝试从 window.location.search 获取（支持 history 模式）
  if (!timeParam) {
    const urlParams = new URLSearchParams(window.location.search);
    timeParam = urlParams.get('time');
  }
  
  if (!timeParam) return null;
  
  // 如果只提供了日期（yyyy-MM-dd），自动补充时间为 00:00:00
  if (/^\d{4}-\d{2}-\d{2}$/.test(timeParam)) {
    return timeParam + ' 00:00:00';
  }
  
  // 如果提供了完整的日期时间格式，直接返回
  if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(timeParam)) {
    return timeParam;
  }
  
  proxy.$confirm(
    `时间参数格式不正确，应为 yyyy-MM-dd 或 yyyy-MM-dd hh:mm:ss，当前值：${timeParam}`,
    '参数格式错误',
    {
      confirmButtonText: '确定',
      showCancelButton: false,
      type: 'warning'
    }
  ).catch(() => {});
  return null;
};

// 生成今天在内的前七天日期
const generateLastSixDays = () => {
  const dates = [];
  for (let i = 6; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(timeFormatNew(date, 'MM.dd'));
  }
  return dates;
};

const activeYear = ref('26届'); // 默认激活项
// 当前时间
const currentTime = ref("");
const currentDate = ref("");
watch(activeYear, async(newVal) => {
  let yearId = null;
  if (newVal === '26届') {
    yearId = 840;
  } else if (newVal === '25届') {
    yearId = 13;
  }
  if (yearId) {
    await getYearData(yearId)
    // 重新启动自动刷新定时器，确保使用新的年份数据
    startAutoRefresh();
  }
},
);

// 今日寄语
const todayMessage = ref([]);
const temperature = ref(0);
const getTodayWeather = async (obj) => {
  const res = await GetWeatherMessage(obj);
  if(res.code === 1){
    weatherType.value = res.result.weatherType;
    temperature.value = res.result.temperature;
  }
}
const loading = ref(false);
// 天气模块数据声明
const weatherType = ref("晴天");

// 时间模块
const time = ref(new Date());

// 今日寄语滚动定时器
const messageTimer = ref(null);

// 5分钟自动刷新定时器
const autoRefreshTimer = ref(null);

// 走马灯
const carouselStates = {
  attendance: {
    ref: ref(null), // 走马灯组件ref
    currentIndex: ref(0), // 当前页码
  },
  earlyArrival: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  exam: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  integral: {
    ref1: ref(null),
    ref2: ref(null),
    currentIndex: ref(0),
  },
  homework: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  wordLearning: {
    ref: ref(null),
    currentIndex: ref(0),
  },
  pkRank: {
    ref: ref(null),
    currentIndex: ref(0),
  },
};

// ---------------出勤模块数据声明---------------
// 班级出勤率数据列表
const schoolAttendanceRate = ref(0);
const attendanceRateList = ref([]);
// 班级早到人数数据列表
const earlyArrivalList = ref([]);

// ---------------出勤模块图表---------------
const attendanceChartRef = ref(null);
let attendanceChart = null;

const attendanceChartData = ref({});

// ----------------线下考试模块数据声明---------------
const currentYearExams = ref([]); // 当年所有考试
const examClassRankList = ref([]); // 班级排名列表，与 currentYearExams 对应
const currentExamIndex = ref(0);   // 当前考试下标
const currentExamCarouselIndex = ref(0); // 当前考试下的走马灯页码
const examCarouselRef = ref(null); // 走马灯ref
let examAutoSwitchTimer = null;

const offlineExamInationChartRef = ref(null);
let offlineExamInationChart = null;

const offlineExamInationChartData = ref({
  dates: [],
  values: [],
});

// 自动切换考试和页的定时器逻辑
const startExamAutoSwitch = () => {
  clearTimeout(examAutoSwitchTimer);
  if (!examClassRankList.value.length || !currentYearExams.value.length) return;
  const currentExamData = examClassRankList.value[currentExamIndex.value];
  if (!currentExamData || !currentExamData.length) {
     examAutoSwitchTimer = setTimeout(switchToNextExam, 5000);
     return;
  };

  const currentPage = currentExamCarouselIndex.value;
  const currentPages = currentExamData.length;

  if (currentPages <= 1) {
    // 只有一页或没有数据，5秒后切换考试
    examAutoSwitchTimer = setTimeout(switchToNextExam, 5000);
  } else {
    // 多页，最后一页5秒后切换考试，否则5秒后切换下一页
    examAutoSwitchTimer = setTimeout(() => {
      if (currentPage >= currentPages - 1) {
        switchToNextExam();
      } else {
        // 切换到下一页
        examCarouselRef.value?.setActiveItem(currentPage + 1);
      }
    }, 5000);
  }
};

// 自动切换逻辑
const handleExamCarouselChange = (index) => {
  currentExamCarouselIndex.value = index;
  startExamAutoSwitch();
};

const switchToNextExam = () => {
  let nextIndex = currentExamIndex.value + 1;
  if (nextIndex >= currentYearExams.value.length) {
    nextIndex = 0;
  }
  currentExamIndex.value = nextIndex;
  currentExamCarouselIndex.value = 0;
  // 走马灯回到第一页
  examCarouselRef.value?.setActiveItem(0);
  startExamAutoSwitch(); // 重启定时器
};

const handleExamDotClick = (index) => {
  currentExamIndex.value = index;
  currentExamCarouselIndex.value = 0;
  examCarouselRef.value?.setActiveItem(0);
  startExamAutoSwitch();
};

// 监听考试切换和数据变化时重启定时器
watch([currentExamIndex, examClassRankList], () => {
  startExamAutoSwitch();
});

// ------------------积分模块数据声明---------------
// 全校积分占比饼图
const schoolIntegralPieChartData = ref([]);
const schoolIntegralPieChartRef = ref(null);
let schoolIntegralPieChart = null;
// 全校积分趋势图
const schoolIntegralTrendChartRef = ref(null);
let schoolIntegralTrendChart = null;

const schoolIntegralTrendData = reactive({
  dates: [],
  values: [],
  fullDates:[],
});
const schoolDefaultData = ref([
  { value: 25, name: "出勤早到", itemStyle: { color: "#FF6B6B" } },
  { value: 20, name: "回答问题", itemStyle: { color: "#A16BFF" } },
  { value: 20, name: "成长记录", itemStyle: { color: "#6BB5FF" } },
  { value: 20, name: "考试成绩", itemStyle: { color: "#6BFF8D" } },
  { value: 15, name: "学习足迹", itemStyle: { color: "#FFA632" } },
]);
// 班级积分列表
const classGroupIntegralList = ref([]);
// 班级积分饼图1
const classIntegralPieChartRef1 = ref(null);
let classIntegralPieChart1 = null;

const classIntegralPieChartData1 = ref()

// 班级积分饼图2
const classIntegralPieChartRef2 = ref(null);
let classIntegralPieChart2 = null;

const classIntegralPieChartData2 = ref()
// 获取积分数据
const findPieChartData = (className, data) => {
  const classData = data.gradeIntegralItemStatisticsDtos.find(item => item.gradeName == className);
  return classData ? classData.gradeIntegralCategoryRateDtos.map(rate => ({
    value: rate.integralCategoryRate,
    name: rate.integralCategoryName,
    itemStyle: {
      color: getColorByCategory(rate.integralCategoryName),
    },
  })) : [];
};

const integralData = ref(null);

const fetchIntegralData = async (obj,nowTime) => {
  // 往前推六十天--查询60天的数据
  const sixDaysAgo = new Date(nowTime);
  sixDaysAgo.setDate(sixDaysAgo.getDate() - 60);
  let startTime = timeFormatNew(sixDaysAgo,'yyyy-MM-dd') + ' 00:00:00';
  let endTime = timeFormatNew(nowTime,'yyyy-MM-dd') + ' 23:59:59';
  const response = await GetIntegralStatistics({gradeIds:obj,inputStartTime:startTime,inputEndTime:endTime});
  if(response.code === 1){
    integralData.value = response.result;
    const data = integralData.value;

    // 更新班级小组积分排名数据
    classGroupIntegralList.value = data.gradeIntegralItemStatisticsDtos?.map(item => ({
      className: item.gradeName,
      groupList: item.integralItemScoreDtos.map((score, index) => ({
        sort: index + 1,
        groupName: score.integralItemName,
        totalIntegra: score.integral,
      })),
    }));

    // 分割数据为顶部和底部列表
    classGroupIntegralListTop.value = classGroupIntegralList.value.filter((_, index) => index % 2 === 0);
    classGroupIntegralListBottom.value = classGroupIntegralList.value.filter((_, index) => index % 2 !== 0);
    if(classGroupIntegralListTop.value?.length >  classGroupIntegralListBottom.value?.length){
      classGroupIntegralListBottom.value.push({
        className: '2026专升本]慧•上岸全程班',
        groupList: []
      });
    }
    classIntegralPieChartData1.value = findPieChartData(classGroupIntegralListTop.value[0]?.className, data);
    classIntegralPieChartData2.value = findPieChartData(classGroupIntegralListBottom.value[0]?.className, data);
    
    // 更新其他数据
    schoolIntegralPieChartData.value = data.schoolIntegralStatisticsDtos.map(item => ({
      value: item.integralCategoryRate,
      name: item.integralCategoryName,
      itemStyle: {
        color: getColorByCategory(item.integralCategoryName),
      },
    }));

    schoolIntegralTrendData.fullDates = data.schoolIntegralWeekStatisticsDtos.map(item => timeFormatNew(item.date,'yyyy-MM-dd'));
    schoolIntegralTrendData.dates = data.schoolIntegralWeekStatisticsDtos.map(item => timeFormatNew(item.date,'MM.dd'));
    schoolIntegralTrendData.values = data.schoolIntegralWeekStatisticsDtos.map(item => item.integral);

    // 初始化图表
    initSchoolIntegralPieChart();
    initSchoolIntegralTrendChart();
    classIntegralInitPieChart1();
    classIntegralInitPieChart2();
  }else{
    // 初始化图表
    initSchoolIntegralPieChart();
    initSchoolIntegralTrendChart();
    classIntegralInitPieChart1();
    classIntegralInitPieChart2();
  }
};

// 根据类别名称获取颜色
const getColorByCategory = (categoryName) => {
  switch (categoryName) {
    case '出勤早到':
      return '#FF6B6B';
    case '回答问题':
      return '#A16BFF';
    case '成长记录':
      return '#6BB5FF';
    case '考试成绩':
      return '#6BFF8D';
    case '学习足迹':
      return '#FFA632';
    default:
      return '#000000'; // 默认颜色
  }
};

const classGroupIntegralListTop = ref([]);
const classGroupIntegralListBottom = ref([]);

const integralIndex = ref(0);


// ----------------作业模块数据声明---------------
// 作业数据提交列表
const homeworkSubmitData = ref([]);

// ----------------单词学习模块数据声明---------------
// 班级单词学习数据
const wordLearningRankData = ref([]);
// 单词书
const wordBook = ref(null);
// 全校单词学习趋势图
const wordLearningChartRef = ref(null);
let wordLearningChart = null;
const wordLearningChartData = ref({
  dates: [],
  fullDates: [],
  values: [],
});

//  PK胜率班级排名
const pkRankData = ref([]);

// 全校周出勤率趋势图
const attendanceInitChart = () => {
  if (attendanceChartRef.value) {
    attendanceChart = echarts.init(attendanceChartRef.value);
    const allZero = attendanceChartData.value.rates.every(item => item.value === 0)
   
   if (allZero) {
    const option = {
      grid: {
        top: "10px",
        left: "0",
        right: "15px",
        bottom: "0",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: generateLastSixDays(),
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
          interval: 0,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        interval: 20,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        axisLabel: {
          formatter: "{value}%",
          color: "#666",
        },
      },
      series: [
        {
          data: [],
          type: "line",
          symbolSize: 8,
          itemStyle: {
            color: "#FFA632",
            borderColor: "#FFA632",
            borderWidth: 2,
          },
          lineStyle: {
            color: "#FFA632",
            width: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255,166,50,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(255,166,50,0.1)",
                },
              ],
            },
          },
        },
      ],
    };
     attendanceChart.setOption(option);
     return;
   }
    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          const index = params[0].dataIndex;
          return `<div style="width:164px;">
              <div style="font-size: 12px; color: #303113; font-weight: 600;">${attendanceChartData.value.fullDates[index]}</div>
              <div style="background-color:#fff; font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between; padding: 6px 8px;">
                <span>全校周出勤率</span>
                <span style="color: #303113; font-weight: 600; font-size: 13px;">${params[0].data}%</span>
              </div>
            </div>`;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 1,
        textStyle: {
          color: "#666",
        },
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#FFA632",
            type: "dashed",
          },
          label: {
            backgroundColor: "#FFA632",
          },
        },
      },
      grid: {
        top: "10px",
        left: "0",
        right: "15px",
        bottom: "0",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: attendanceChartData.value.dates,
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
          interval: 0,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        interval: 20,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        axisLabel: {
          formatter: "{value}%",
          color: "#666",
        },
      },
      series: [
        {
          data: attendanceChartData.value.rates,
          type: "line",
          symbolSize: 8,
          itemStyle: {
            color: "#FFA632",
            borderColor: "#FFA632",
            borderWidth: 2,
          },
          lineStyle: {
            color: "#FFA632",
            width: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255,166,50,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(255,166,50,0.1)",
                },
              ],
            },
          },
        },
      ],
    };
    attendanceChart.setOption(option);
  } 
};

// 全校积分占比饼图
const initSchoolIntegralPieChart = () => {
  schoolIntegralPieChart = echarts.init(schoolIntegralPieChartRef.value);

  if (schoolIntegralPieChartRef.value) {
    const allZero = schoolIntegralPieChartData.value.every(item => item.value === 0);
    
    if (allZero) {
      const option = {
        legend: {
          orient: "vertical",
          left: "60%",
          top: "center",
          itemWidth: 15,
          itemHeight: 15,
          itemGap: 10,
          textStyle: {
            padding: [0, 0, 0, 10]
          },
          formatter: (name) => {
            const item = schoolDefaultData.value.find((d) => d.name === name);
            return `${name}    ${item.value.toFixed(2)}%`;
          },
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "24%",
              top: "36%",
              style: {
                text: "出勤\n早到",
                textAlign: "center",
                fill: "#303133",
                fontSize: 28,
                fontWeight: "bold",
              },
              z: 100,
            },
          ],
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "90%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            emphasis: {
              scale: true,
              scaleSize: 8,
            },
            itemStyle: {
              borderRadius: 2,
              borderWidth: 2,
              borderColor: "#fff",
            },
            data: schoolDefaultData.value,
          },
        ],
      };
      schoolIntegralPieChart.setOption(option);
      return;
    }

    const option = {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          const item = schoolIntegralPieChartData.value.find((i) => i.name === params.name);
          const percent = item ? item.value.toFixed(2) : "0.00";
          return `
            <div style="display:flex; align-items:center; width:164px;height:32px;background-color:#fff;padding:0px 8px;">
              <div style="background-color:${params.color}; width:12px; height:12px"></div>
              <div style="flex:1;padding-left:8px; display:flex;justify-content:space-between;font-size:12px;color:#606266;">
                <span>${params.name}</span>
                <span style="color:#303133;font-weight:600;font-size:13px;">${percent}%</span>
                </div>
            </div>
            `;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 0,
      },
      legend: {
        orient: "vertical",
        left: "60%",
        top: "center",
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 10,
        textStyle: {
          padding: [0, 0, 0, 10]
        },
        formatter: (name) => {
          const item = schoolIntegralPieChartData.value.find((d) => d.name === name);
          return `${name}    ${item.value.toFixed(2)}%`;
        },
      },
      graphic: {
        elements: [
          {
            type: "text",
            left: "24%",
            top: "36%",
            style: {
              text: "出勤\n早到",
              textAlign: "center",
              fill: "#303133",
              fontSize: 28,
              fontWeight: "bold",
            },
            z: 100,
          },
        ],
      },
      series: [
        {
          type: "pie",
          radius: ["50%", "90%"],
          center: ["30%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          emphasis: {
            scale: true,
            scaleSize: 8,
          },
          itemStyle: {
            borderRadius: 4,
            borderWidth: 2,
            borderColor: "#fff",
          },
          data: schoolIntegralPieChartData.value,
        },
      ],
    };
    schoolIntegralPieChart.setOption(option);
  }
};

// 全校线下考试平均分趋势图
const initOfflineExamInationChart = () => {
  if (offlineExamInationChartRef.value) {
    offlineExamInationChart = echarts.init(offlineExamInationChartRef.value);
    const allZero = offlineExamInationChartData.value.values.every(item => item.value === 0)
    if (allZero) {
      const option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // 处理长名称换行
            const formatName = (name) => {
              if (name.length > 8) {
                // 每12个字符换一行
                return name.replace(/(.{8})/g, '$1<br>');
              }
              return name;
            };
            
            return `<div style="width:164px;">
                <div style="font-size: 12px; color: #303113; font-weight: 600;">全校线下考试平均分</div>
                <div style="background-color:#fff; font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between;padding: 6px 8px;">
                  <span style="word-break: break-all;">${formatName(params[0].name)}</span>
                  <span style="color: #303113; font-weight: 600; font-size: 13px; margin-left: 8px;">${params[0].value}</span>
                </div>
              </div>`;
          },
          backgroundColor: "#F3F3F3",
          borderWidth: 1,
          position: function (pos, params, el, elRect, size) {
            const obj = { top: 10 };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          extraCssText: "z-index: 100;",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "#FFA632",
              type: "dashed",
            },
            label: {
              backgroundColor: "#FFA632",
            },
          },
        },
        grid: {
          top: "10px",
          left: "20px",
          right: "5px",
          bottom: "5px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: [`${ activeYear.value }英语摸底考试` ,`${ activeYear.value }《基础语法》考试`,`${ activeYear.value }《语篇精讲》考试`,`${ activeYear.value }《核心语法》考试`,`${ activeYear.value }英语模考二`],
          axisLine: {
            lineStyle: {
              color: "#E5E5E5",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#666",
            interval: 0,
            rotate: 45, 
            fontSize: 10,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ["rgba(250,250,250,0.3)", "rgba(245,245,245,0.3)"],
            },
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          interval: 20,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: false,
            showSymbol: true,
            symbolSize: 8,
            itemStyle: {
              color: "#FFA632",
              borderColor: "#FFA632",
              borderWidth: 2,
            },
            lineStyle: {
              color: "#FFA632",
              width: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,166,50,0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255,166,50,0.1)",
                  },
                ],
              },
            },
          },
        ],
      };
      offlineExamInationChart.setOption(option);
      return;
    }
    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          // 处理长名称换行
          const formatName = (name) => {
            if (name.length > 8) {
              // 每12个字符换一行
              return name.replace(/(.{8})/g, '$1<br>');
            }
            return name;
          };
          
          return `<div style="width:164px;">
              <div style="font-size: 12px; color: #303113; font-weight: 600;">全校线下考试平均分</div>
              <div style="background-color:#fff; font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between;padding: 6px 8px;">
                <span style="word-break: break-all;">${formatName(params[0].name)}</span>
                <span style="color: #303113; font-weight: 600; font-size: 13px; margin-left: 8px;">${params[0].value}</span>
              </div>
            </div>`;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 1,
        position: function (pos, params, el, elRect, size) {
          const obj = { top: 10 };
          obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
          return obj;
        },
        extraCssText: "z-index: 100;",
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#FFA632",
            type: "dashed",
          },
          label: {
            backgroundColor: "#FFA632",
          },
        },
      },
      grid: {
        top: "10px",
        left: "20px",
        right: "5px",
        bottom: "5px",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: [
          ...offlineExamInationChartData.value.dates,
        ],
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
          interval: 0,
          rotate: 45, 
          fontSize: 10,
          formatter: function (value) {
            return value.length > 10 ? value.slice(0,10) : value;
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ["rgba(250,250,250,0.3)", "rgba(245,245,245,0.3)"],
          },
        },
      },
      yAxis: {
        type: "value",
        min: 0,
        max: 100,
        interval: 20,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        axisLabel: {
          color: "#666",
        },
      },
      series: [
        {
          data: offlineExamInationChartData.value.values,
          type: "line",
          smooth: false,
          showSymbol: true,
          symbolSize: 8,
          itemStyle: {
            color: "#FFA632",
            borderColor: "#FFA632",
            borderWidth: 2,
          },
          lineStyle: {
            color: "#FFA632",
            width: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255,166,50,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(255,166,50,0.1)",
                },
              ],
            },
          },
        },
      ],
    };
    offlineExamInationChart.setOption(option);
  }
};

// 全校积分趋势图
const initSchoolIntegralTrendChart = () => {
  if (schoolIntegralTrendChartRef.value) {
    schoolIntegralTrendChart = echarts.init(schoolIntegralTrendChartRef.value);
    // 计算最大值和最小值
    const maxValue = Math.max(...schoolIntegralTrendData.values);
    const minValue = Math.min(...schoolIntegralTrendData.values);
    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          const index = params[0].dataIndex;
          return `<div style="width:164px;">
              <div style="font-size: 12px; color: #303113; font-weight: 600;">${schoolIntegralTrendData.fullDates[index]}</div>
              <div style="background-color:rgba(255, 255, 255, 0.80); font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between;padding: 6px 8px;">
                <span>全校积分</span>
                <span style="color: #303113; font-weight: 600; font-size: 13px;">${params[0].data}</span>
              </div>
            </div>`;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 1,
        textStyle: {
          color: "#666",
        },
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#FFA632",
            type: "dashed",
          },
          label: {
            backgroundColor: "#FFA632",
          },
        },
      },
      grid: {
        top: "20px",
        left: "10px",
        right: "15px",
        bottom: "0",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: schoolIntegralTrendData.dates,
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
      },
      yAxis: {
        type: "value",
        min: minValue - 20 < 0 ? 0 : minValue - 20,
        max: maxValue + 20,
        interval: minValue == maxValue ? 20 : (minValue + maxValue) / 5, // 动态间隔
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        axisLabel: {
          color: "#666",
        },
      },
      series: [
        {
          data: schoolIntegralTrendData.values,
          type: "line",
          smooth: false,
          symbolSize: 8,
          lineStyle: {
            color: "#FFA632",
            width: 2,
          },
          itemStyle: {
            color: "#FFA632",
            borderColor: "#FFA632",
            borderWidth: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255,166,50,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(255,166,50,0.1)",
                },
              ],
            },
          },
        },
      ],
    };

    // 添加无数据状态
    if (schoolIntegralTrendData.dates.length === 0 || schoolIntegralTrendData.values.length === 0) {
      const option = {
        grid: {
          top: "20px",
          left: "10px",
          right: "15px",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: generateLastSixDays(),
          axisLine: {
            lineStyle: {
              color: "#E5E5E5",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#666",
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          interval: 20, // 间隔
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: false,
            symbolSize: 8,
            lineStyle: {
              color: "#FFA632",
              width: 2,
            },
            itemStyle: {
              color: "#FFA632",
              borderColor: "#FFA632",
              borderWidth: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,166,50,0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255,166,50,0.1)",
                  },
                ],
              },
            },
          },
        ],
      };
      schoolIntegralTrendChart.setOption(option);
      return;
    }

    schoolIntegralTrendChart.setOption(option);
  }
};

// 班级积分占比饼图1
const classIntegralInitPieChart1 = () => {
  
  if (classIntegralPieChartRef1.value) {
    if (classIntegralPieChart1) {
      classIntegralPieChart1.dispose(); // 销毁旧的图表实例
    }
    classIntegralPieChart1 = echarts.init(classIntegralPieChartRef1.value);
    const allZero = classIntegralPieChartData1.value?.every(item => item.value == 0)
      if (allZero) {
          const option = {
            legend: {
              orient: "vertical",
              right: "1%",
              top: "middle",
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 6,
              textStyle: {
                color: "#666",
                fontSize: 12,
                padding: [0, 0, 0, 5]
              },
              formatter: (name) => {
                const item = schoolDefaultData.value.find((d) => d.name === name);
                return `${name}  ${item.value}%`;
              },
            },
            graphic: {
              elements: [
                {
                  type: "text",
                  left: "17%",
                  top: "37%",
                  style: {
                    text: "积分\n占比",
                    textAlign: "center",
                    fill: "#303133",
                    fontSize: 14,
                    fontWeight: "bold",
                  },
                  z: 100,
                },
              ],
            },
            series: [
              {
                type: "pie",
                radius: ["45%", "85%"],
                center: ["23%", "50%"],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  borderRadius: 1,
                  borderWidth: 2,
                  borderColor: "#fff",
                },
                data: schoolDefaultData.value,
              },
            ],
          };
          classIntegralPieChart1.setOption(option);
          return;
      }
      const option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            const item = classIntegralPieChartData1.value.find((i) => i.name === params.name);
            const percent = item ? item.value.toFixed(2) : "0.00";
            return `
              <div style="display:flex; align-items:center; width:164px;height:32px;background-color:#fff;padding:0px 8px;">
                <div style="background-color:${params.color}; width:12px; height:12px"></div>
                <div style="flex:1;padding-left:8px; display:flex;justify-content:space-between;font-size:12px;color:#606266;">
                  <span>${params.name}</span>
                  <span style="color:#303133;font-weight:600;font-size:13px;">${percent}%</span>
                  </div>
              </div>
              `;
          },
          backgroundColor: "#F3F3F3",
          borderWidth: 0,
        },
        legend: {
          orient: "vertical",
          right: "1%",
          top: "middle",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 6,
          textStyle: {
            color: "#666",
            fontSize: 12,
            padding: [0, 0, 0, 5]
          },
          formatter: (name) => {
            const item = classIntegralPieChartData1.value.find((d) => d.name === name);
            return `${name}  ${item.value}%`;
          },
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "17%",
              top: "37%",
              style: {
                text: "积分\n占比",
                textAlign: "center",
                fill: "#303133",
                fontSize: 14,
                fontWeight: "bold",
              },
              z: 100,
            },
          ],
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "85%"],
            center: ["23%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderRadius: 1,
              borderWidth: 2,
              borderColor: "#fff",
            },
            data: classIntegralPieChartData1.value,
          },
        ],
      };
      classIntegralPieChart1.setOption(option);
  }
};

// 班级积分占比饼图2
const classIntegralInitPieChart2 = () => {
  if (classIntegralPieChartRef2.value) {
    if (classIntegralPieChart2) {
      classIntegralPieChart2.dispose(); // 销毁旧的图表实例
    }
    classIntegralPieChart2 = echarts.init(classIntegralPieChartRef2.value);
    const allZero = classIntegralPieChartData2.value?.every(item => item.value === 0)
   
    if (allZero) {
      const option = {
        legend: {
          orient: "vertical",
          right: "1%",
          top: "middle",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 6,
          textStyle: {
            color: "#666",
            fontSize: 12,
            padding: [0, 0, 0, 5]
          },
          formatter: (name) => {
            const item = schoolDefaultData.value.find((d) => d.name === name);
            return `${name}  ${item.value}%`;
          },
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "17%",
              top: "37%",
              style: {
                text: "积分\n占比",
                textAlign: "center",
                fill: "#303133",
                fontSize: 14,
                fontWeight: "bold",
              },
              z: 100,
            },
          ],
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "85%"],
            center: ["23%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderRadius: 1,
              borderWidth: 2,
              borderColor: "#fff",
            },
            data: schoolDefaultData.value,
          },
        ],
      };
      classIntegralPieChart2.setOption(option);
      return;
    }
    const option = {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          const item = classIntegralPieChartData2.value?.find((i) => i.name === params.name);
          const percent = item ? item.value.toFixed(2) : "0.00";
          return `
            <div style="display:flex; align-items:center; width:164px;height:32px;background-color:#fff;padding:0px 8px;">
              <div style="background-color:${params.color}; width:12px; height:12px"></div>
              <div style="flex:1;padding-left:8px; display:flex;justify-content:space-between;font-size:12px;color:#606266;">
                <span>${params.name}</span>
                <span style="color:#303133;font-weight:600;font-size:13px;">${percent}%</span>
                </div>
            </div>
            `;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 0,
      },
      legend: {
        orient: "vertical",
        right: "1%",
        top: "middle",
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 6,
        textStyle: {
            color: "#666",
            fontSize: 12,
            padding: [0, 0, 0, 5]
          },
        formatter: (name) => {
          const item = classIntegralPieChartData2.value.find((d) => d.name === name);
          return `${name}  ${item.value}%`;
        },
      },
      graphic: {
        elements: [
          {
            type: "text",
            left: "17%",
            top: "37%",
            style: {
              text: "积分\n占比",
              textAlign: "center",
              fill: "#303133",
              fontSize: 14,
              fontWeight: "bold",
            },
            z: 100,
          },
        ],
      },
      series: [
        {
          type: "pie",
          radius: ["45%", "85%"],
          center: ["23%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          itemStyle: {
            borderRadius: 1,
            borderWidth: 2,
            borderColor: "#fff",
          },
          data: classIntegralPieChartData2.value,
        },
      ],
    };
    classIntegralPieChart2.setOption(option);
  }
};

// 全校学习趋势图
const initWordLearningChart = () => {
  if (wordLearningChartRef.value) {
    wordLearningChart = echarts.init(wordLearningChartRef.value);
    const allZero = wordLearningChartData.value.values.every(item => item === 0)
    if (allZero) {
      const option = {
        grid: {
          top: "8px",
          left: "10px",
          right: "15px",
          bottom: "0px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: generateLastSixDays(),
          axisLine: {
            lineStyle: {
              color: "#E5E5E5",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#666",
            rotate: 40,
            interval: 0,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          interval: 20,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#E5E5E5",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: false,
            showSymbol: true,
            symbolSize: 8,
            lineStyle: {
              color: "#FFA632",
              width: 2,
            },
            itemStyle: {
              color: "#FFA632",
              borderColor: "#FFA632",
              borderWidth: 2,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,166,50,0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255,166,50,0.1)",
                  },
                ],
              },
            },
          },
        ],
      };
      wordLearningChart.setOption(option);
      return;
    }
    
    // 最大值最小值
    const counts = wordLearningChartData.value.values;
    const minCount = Math.min(...counts);
    const maxCount = Math.max(...counts);
    // 间距
    const interval = Math.ceil((maxCount - minCount) / 5);
    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (params) {
          const index = params[0].dataIndex;
          return `<div style="width:164px;">
              <div style="font-size: 12px; color: #303113; font-weight: 600;">${wordLearningChartData.value.fullDates[index]}</div>
              <div style="background-color:#fff; font-size: 12px; color: #606266;font-weight: 400;display: flex;justify-content: space-between; padding: 6px 8px;">
                <span>全校单词学习</span>
                <span style="color: #303113; font-weight: 600; font-size: 13px;">${params[0].data}</span>
              </div>
            </div>`;
        },
        backgroundColor: "#F3F3F3",
        borderWidth: 1,
        textStyle: {
          color: "#666",
        },
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#FFA632",
            type: "dashed",
          },
          label: {
            backgroundColor: "#FFA632",
          },
        },
      },
      grid: {
        top: "8px",
        left: "10px",
        right: "15px",
        bottom: "0px",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: wordLearningChartData.value.dates,
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#666",
          interval: 0,
          rotate: 40,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
      },
      yAxis: {
        type: "value",
        min: minCount,
          max: maxCount,
          interval: interval,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
            type: "dashed",
          },
        },
        axisLabel: {
          color: "#666",
        },
      },
      series: [
        {
          data: wordLearningChartData.value.values,
          type: "line",
          smooth: false,
          showSymbol: true,
          symbolSize: 8,
          lineStyle: {
            color: "#FFA632",
            width: 2,
          },
          itemStyle: {
            color: "#FFA632",
            borderColor: "#FFA632",
            borderWidth: 2,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(255,166,50,0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(255,166,50,0.1)",
                },
              ],
            },
          },
        },
      ],
    };
    wordLearningChart.setOption(option);
  }
};

// 天气
const getImageSrc = (weatherType) => {
  if (weatherType?.includes("云"))
    return "https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png";
  if (weatherType?.includes("雨"))
    return "https://appfile2.sbgw.cn/hhxtj/dafe68ee897240d0a24d2ffcb41f485f.png";
  if (weatherType?.includes("雪"))
    return "https://appfile2.sbgw.cn/hhxtj/fcced926fa5543339ca2e30324ec48cc.png";
  if (weatherType?.includes("晴") || weatherType?.includes("阳"))
    return "https://appfile2.sbgw.cn/hhxtj/0d770c0355dc4fb8bc36fa3f6d40e4ec.png";
  // 可以在这里添加默认情况
  return "https://appfile2.sbgw.cn/hhxtj/2fff8c51447d470495e123ee64c421e5.png"; // 返回默认图片路径
};

// 处理时间
const updateTime = () => {
  // 获取当前时间
  const now = new Date();
  // 格式化时间为字符串
  const formattedTime = now.toLocaleTimeString();
  currentTime.value = formattedTime;
  // 每秒更新一次时间
  setTimeout(() => updateTime(), 1000);
  // 获取当前日期
  const nowDay = new Date();

  // 格式化日期
  const year = nowDay.getFullYear();
  const month = String(nowDay.getMonth() + 1).padStart(2, "0");
  const day = String(nowDay.getDate()).padStart(2, "0");
  currentDate.value = `${year}.${month}.${day}`;
};

// 处理班级积分数据
const handleClassGroupIntegralList = () => {
  classGroupIntegralList.value.forEach((item, index) => {
    if (index % 2 === 0) {
      classGroupIntegralListTop.value.push(item);
    } else {
      classGroupIntegralListBottom.value.push(item);
    }
  });
};

// 监听窗口大小变化
let resizeTimer = null;
const handleResize = () => {
  if (resizeTimer) clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    attendanceChart && attendanceChart.resize();
    offlineExamInationChart && offlineExamInationChart.resize();
    schoolIntegralPieChart && schoolIntegralPieChart.resize();
    schoolIntegralTrendChart && schoolIntegralTrendChart.resize();
    classIntegralPieChart1 && classIntegralPieChart1.resize();
    classIntegralPieChart2 && classIntegralPieChart2.resize();
    wordLearningChart && wordLearningChart.resize();
  }, 1000); // 1000
};

// 走马灯相关设置
const setCarouselActivePage = (type, index) => {
  if (type === "integral") {
    integralIndex.value = index;
    carouselStates[type].currentIndex.value = index;
    
    // 确保两个走马灯状态同步
    if (carouselStates[type].ref1.value) {
      carouselStates[type].ref1.value.setActiveItem(index);
    }
    if (carouselStates[type].ref2.value) {
      carouselStates[type].ref2.value.setActiveItem(index);
    }
    
    updatePieChartData(index);
    classIntegralInitPieChart1(); // 重新初始化饼图1
    classIntegralInitPieChart2(); // 重新初始化饼图2
  } else {
    carouselStates[type].currentIndex.value = index;
    carouselStates[type].ref.value?.setActiveItem(index);
  }
};

const updatePieChartData = (index) => {
  if (integralData.value) {
    classIntegralPieChartData1.value = findPieChartData(classGroupIntegralListTop.value[index]?.className, integralData.value);
    classIntegralPieChartData2.value = findPieChartData(classGroupIntegralListBottom.value[index]?.className, integralData.value);
  }
};

// 在轮转事件中调用更新函数
const handleCarouselChange = (type, index) => {
  if (type === "integral") {
    integralIndex.value = index;
    
    // 确保两个走马灯状态同步
    if (carouselStates[type].ref1.value) {
      carouselStates[type].ref1.value.setActiveItem(index);
    }
    if (carouselStates[type].ref2.value) {
      carouselStates[type].ref2.value.setActiveItem(index);
    }
    
    updatePieChartData(index);
    classIntegralInitPieChart1(); // 重新初始化饼图1
    classIntegralInitPieChart2(); // 重新初始化饼图2

    carouselStates[type].currentIndex.value = index;
  } else {
    carouselStates[type].currentIndex.value = index;
  }
};

// 获取作业提交数据
const fetchHomeworkSubmitData = async (obj, date) => {
  const groupedData = [];
  const response = await GetLatestWorkStatistics(obj, date);
  if (response.code === 1) {
    const data = response.result;
    for (let i = 0; i < data?.length; i += 8) {
      groupedData.push(data.slice(i, i + 8));
    }
  }
  homeworkSubmitData.value = groupedData;
};

// 获取出勤统计数据
const fetchAttendanceData = async (obj,nowTime) => {
  const response = await GetAttendanceStatistics(obj,nowTime);
  if (response.code === 1) {
    const data = response.result;
    todayMessage.value = data.todayMessages;
    schoolAttendanceRate.value = data.schoolAttendance || 0;
    // 更新班级出勤率数据
    const groupData = (data, groupSize) => {
      return data.reduce((result, item, index) => {
        const groupIndex = Math.floor(index / groupSize);
        if (!result[groupIndex]) {
          result[groupIndex] = [];
        }
        result[groupIndex].push(item);
        return result;
      }, []);
    };
    attendanceRateList.value = groupData(data.gradeAttendanceDtos.map((item, sort) => ({
      sort: sort + 1,
      className: item.gradeName,
      attendanceRate: item.gradeAttendanceRate,
    })), 5);

    // 更新早到人数数据
    earlyArrivalList.value = groupData(data.gradeEarlyDtos.map((item, sort) => ({
      sort: sort + 1,
      className: item.gradeName,
      count: item.earlyCount,
    })), 5);
    attendanceChartData.value.dates = data.schoolWeekAttendanceDtos.map(item => timeFormatNew(item.data,'MM.dd') );
    attendanceChartData.value.rates = data.schoolWeekAttendanceDtos.map(item => item.schoolWeekAttendanceRate);
    attendanceChartData.value.fullDates = data.schoolWeekAttendanceDtos.map(item => timeFormatNew(item.data,'yyyy-MM-dd'));
    // 初始化相关图表
    attendanceInitChart();
  }else{
    todayMessage.value = [];
  }
  if(todayMessage.value.length == 0){
    todayMessage.value = [`${ activeYear.value }全程先锋2班（光谷）寄语：付出努力的人，总能比别人走的更远，成就更大`];
  }
};

// 工具函数：分组
const groupExamData = (data, groupSize) => {
  const grouped = [];
  for (let i = 0; i < data.length; i += groupSize) {
    grouped.push(data.slice(i, i + groupSize));
  }
  return grouped;
};

// 获取线下考试相关数据
const fetchOfflineExamsData = async (gradeIds,yearId, date) => {
  const response = await GetOfflineExaminationAverageScores( gradeIds,yearId, date );

  if (response.code === 1 && response.result) {
    const { offlineExaminationAverageScoreListDtos, offlineExamStatisticsResultDtos } = response.result;

    // 1. 填充图表数据
    if (offlineExaminationAverageScoreListDtos && offlineExaminationAverageScoreListDtos.length > 0) {
      offlineExamInationChartData.value.dates = offlineExaminationAverageScoreListDtos.map(item => item.reportName);
      offlineExamInationChartData.value.values = offlineExaminationAverageScoreListDtos.map(item => item.averageScore);
    } else {
      offlineExamInationChartData.value.dates = [];
      offlineExamInationChartData.value.values = [];
    }
    initOfflineExamInationChart();

    // 2. 填充考试列表和排名
    if (offlineExamStatisticsResultDtos && offlineExamStatisticsResultDtos.length > 0) {
      currentYearExams.value = offlineExamStatisticsResultDtos.map(exam => ({
        id: offlineExaminationAverageScoreListDtos.find(e => e.reportName === exam.reportName)?.examinationID,
        title: exam.reportName,
      }));

      const allExamData = offlineExamStatisticsResultDtos.map(exam => {
        if (exam.offlineExamStatisticsSimpleDtos && exam.offlineExamStatisticsSimpleDtos.length > 0) {
          const dataList = exam.offlineExamStatisticsSimpleDtos.map((item, idx) => ({
            ...item,
            sort: idx + 1,
          }));
          return groupExamData(dataList, 9);
        }
        return [];
      });
      examClassRankList.value = allExamData;
    } else {
      currentYearExams.value = [];
      examClassRankList.value = [];
    }
  } else {
    // 接口异常或无数据
    offlineExamInationChartData.value.dates = [];
    offlineExamInationChartData.value.values = [];
    initOfflineExamInationChart();
    currentYearExams.value = [];
    examClassRankList.value = [];
  }
};


// 获取学习单词统计
const fetchGradeStudyRankAsync = async (obj,nowTime) => {
  const response = await GetGradeStudyRankAsync(obj,nowTime);
  if (response.code === 1) {
    const data = response.data || [];
    let dataList = [];
    dataList = data.gradeRanks.map((item, index) => ({
      ...item,
      sort: index + 1,
    }));
    const groupedData = [];
    for (let i = 0; i < dataList.length; i += 5) {
      groupedData.push(dataList.slice(i, i + 5));
    }
    wordLearningRankData.value = groupedData;
    wordBook.value = data.topBook?.bookName;
    wordLearningChartData.value.dates = data.dateRanks.map(item => timeFormatNew(item.date,'MM.dd'));
    wordLearningChartData.value.fullDates = data.dateRanks.map(item => timeFormatNew(item.date,'yyyy-MM-dd'));
    wordLearningChartData.value.values = data.dateRanks.map(item => item.wordCount);
    initWordLearningChart();
  }else{
    wordLearningRankData.value = [];
    wordBook.value = null
    wordLearningChartData.value.dates = [];
    wordLearningChartData.value.fullDates = [];
    wordLearningChartData.value.values = [];
  }
}

const fetchGradeRoomRank = async (obj) => {
  const response = await GetPracticeStatistics(obj);
  if (response.code === 1) {
    const data = response.data || [];
    let dataList = [];
    dataList = data.map((item, index) => ({
      ...item,
      sort: index + 1,
    }));
    const groupedData = [];
    for (let i = 0; i < dataList.length; i += 5) {
      groupedData.push(dataList.slice(i, i + 5));
    }
    pkRankData.value = groupedData;
  }else{
    pkRankData.value = [];
  }
}

const getYearData = async(yearId) => {
  loading.value = true;
  const res = await GetNowYearGradeIds({ yearId });
  if(res.code === 1){
    let nowTime;
    // 先检查URL中是否有时间参数
    const urlTime = getUrlTimeParam();
    if(urlTime){
      // 如果URL中有时间参数，使用URL的时间
      nowTime = urlTime;
    } else if(yearId == 13){
      // 获取去年今日的日期
      const lastYear = new Date();
      lastYear.setFullYear(lastYear.getFullYear() - 1);
      nowTime = timeFormatNew(lastYear, 'yyyy-MM-dd hh:mm:ss');
    } else {
      // 获取当前日期
      nowTime = timeFormatNew(new Date(), 'yyyy-MM-dd hh:mm:ss');
    }
    fetchAttendanceData(res.result,nowTime);// 出勤统计
    fetchIntegralData(res.result,nowTime);// 积分统计
    handleClassGroupIntegralList(res.result);// 班级积分
    fetchHomeworkSubmitData(res.result, urlTime);// 作业提交
    getTodayWeather();// 今日天气
    fetchOfflineExamsData(res.result,yearId, urlTime) // 获取当年的班级考试信息
    fetchGradeStudyRankAsync(res.result,nowTime) // 获取学习单词统计
    fetchGradeRoomRank(res.result) // 获取pk胜率前一百
  }
  loading.value = false;
}

// 启动5分钟自动刷新
const startAutoRefresh = () => {
  // 清除之前的定时器
  if (autoRefreshTimer.value) {
    clearInterval(autoRefreshTimer.value);
  }
  
  // 设置5分钟（300000毫秒）定时器
  autoRefreshTimer.value = setInterval(() => {
    // 根据当前激活的年份获取对应的yearId
    let yearId = null;
    if (activeYear.value === '26届') {
      yearId = 840;
    } else if (activeYear.value === '25届') {
      yearId = 13;
    }
    
    if (yearId) {
      getYearData(yearId);
    }
  }, 5 * 60 * 1000); // 5分钟 = 300000毫秒
};

// 停止自动刷新
const stopAutoRefresh = () => {
  if (autoRefreshTimer.value) {
    clearInterval(autoRefreshTimer.value);
    autoRefreshTimer.value = null;
  }
};

onMounted(() => {
    // 检查登录状态
    const isLogin = sessionStorage.getItem('isLogin');
    if (isLogin == 'false' || isLogin === null) {
      // 设置大屏标识
      sessionStorage.setItem('isLargeScreen', 'true');
      // 存储当前页面路径，用于登录后跳转回来
      sessionStorage.setItem('largeScreenPath', proxy.$route.fullPath);
      
      // 弹出提示框
      proxy.$confirm('请账号密码登录或钉钉扫码登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // 用户点击确定后跳转到登录页面
        proxy.$router.push('/');
      }).catch(() => {
        // 用户点击取消，清除大屏标识
      });
      return;
    }
  updateTime();
  getYearData('840')
  window.addEventListener("resize", handleResize);
  startExamAutoSwitch();
  // 启动5分钟自动刷新
  startAutoRefresh();
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  if (resizeTimer) clearTimeout(resizeTimer);
  attendanceChart && attendanceChart.dispose();
  offlineExamInationChart && offlineExamInationChart.dispose();
  schoolIntegralPieChart && schoolIntegralPieChart.dispose();
  schoolIntegralTrendChart && schoolIntegralTrendChart.dispose();
  classIntegralPieChart1 && classIntegralPieChart1.dispose();
  classIntegralPieChart2 && classIntegralPieChart2.dispose();
  wordLearningChart && wordLearningChart.dispose();
  clearTimeout(examAutoSwitchTimer); // 新增：清理定时器
  // 清理今日寄语滚动定时器
  if (messageTimer.value) {
    clearInterval(messageTimer.value);
  }
  // 清理5分钟自动刷新定时器
  stopAutoRefresh();
  startScrolling();
});

// 确保数据分组逻辑正确
const groupData = (data, groupSize) => {
  const grouped = [];
  for (let i = 0; i < data.length; i += groupSize) {
    grouped.push(data.slice(i, i + groupSize));
  }
  return grouped;
};

const startScrolling = () => {
  const content = document.querySelector('.top-right-content');
  if (content) {
    const width = content.offsetWidth;
    content.style.animationDuration = `${width / 50}s`; // 滚动速度自适应内容长度
  }
};

watchEffect(() => {
  if (todayMessage.value.length > 0) {
    nextTick(startScrolling);
  }
});
classGroupIntegralListTop.value = groupData(classGroupIntegralList.value, 2);
classGroupIntegralListBottom.value = groupData(classGroupIntegralList.value.slice(2), 2);
</script>

<style scoped lang="scss">
.body {
  width: 100vw;
  height: 100%;
  min-height: 0;
  background: #F5F4F0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

.report-path {
  position: absolute;
  top: 6.7%;
  left: 58px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.top {
  position: relative;
  height: 7.5vh;
  min-height: 56px;
}

.top-left {
  position: absolute;
  top: 40%;
  left: 58px;
  transform: translateY(-50%);
  font-size: 16px;
  display: flex;
  align-items: center;

  .weather_img {
    width: 20px;
    height: 20px;
  }

  .weather_text {
    padding-left: 8px;
  }
}

.top-right {
  position: absolute;
  top: 40%;
  right: 0;
  transform: translateY(-50%);
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  overflow: hidden;

  .msg_img{
    width: 20px;
    height: 20px;
  }

  .top-right-content-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    width: 380px;
    height: 24px;
    overflow: hidden;
    margin-right: 30px;
  }

  .top-right-content {
    position: absolute;
    white-space: nowrap;
    padding-left: 8px;
    animation: scrollText 10s linear infinite; /* 10秒完成一次滚动，无限循环 */
  }

  .top-right-content ul {
    position: absolute;
    left: 0;
    top: -12px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .top-right-content ul li {
    float: left;
    color: #333;
    font-size: 16px;
    margin-right: 15px;
  }
}

@keyframes scrollText {
  0% {
    transform: translateX(0%);
    opacity: 0;
    opacity: 1;
  }

  100% {
    transform: translateX(-100%);
    opacity: 1;
  }
}

.content {
  flex: 1 1 0;
  display: flex;
  height: 0;
  min-height: 0;
  padding: 0 1.7vh;
  padding-top: 18px;
  gap: 16px;

  .card {
    width: 100%;
    padding: 16px 24px;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/964591dd11214604b7ef7daaa59c630e.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .word-card{
    width: 100%;
    padding: 16px 24px;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/9d81d164a05d48fcb3dba0abd52e6528.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 50.6vh;
  }

  .integral-card{
    height: 89.9vh;
    background-color: #F9F9F9;
    background-size: 100% 100%;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/0feb681ddae7401a9a67b65ed12b7384.png") !important;
    background-repeat: no-repeat;
    padding: 16px 5px 16px 24px;
    margin-top: -0.5px;
  }

  .card-title {
    font-size: 28px;
    font-weight: 600;
    display: flex;
    align-items: flex-end;

    .card-title-right {
      margin-left: 16px;
      margin-bottom: 15px;
      font-weight: 500;
      font-size: 12px;

      .number{
        margin-left: 4px;
        font-size: 16px;
        font-weight: 600;
      }
    }

    .subtitle {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      margin-bottom: 2px;
      margin-left: 10px;

      .subtitle-title {
        font-size: 16px;
        font-weight: 600;
      }

      .subtitle-text {
        font-size: 11px;
        color: #666;
      }
    }
  }

  .segmentation {
    width: 100%;
    margin-top: -30px;
  }

  .content-left {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // align-items: center;
    width: 37.3%;

    .attendance {
      width: 100%;
      // height: 100%;
    }

    .attendance-rate {
      margin-top: 16px;

      .chart-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        display: flex;
        justify-content: center;
      }

      .chart-container {
        display: block;
        width: 100%;
        height: 13.2vh;
        margin: 0;
        padding: 0;
      }
    }

    .offline-examination {
      // height: 100%;
      margin-bottom: 1.1%;

      .offline-examination-left {
        width: 50%;
      }

      .offline-examination-right {
        width: 50%;
        height: 33vh;
      }

      .chart-container {
        width: 100%;
        height: 100%;
      }
    }
  }

  .content-Middle {
    width: 28.1%;
  }

  .content-right {
    width: 32.2%;
  }

  .content-right-top{
    display: flex;
    justify-content: flex-end;
    font-size: 13px;
    font-weight: 400;
    color: #333;
    margin-top: -31px;
  }

  .content-right-top-item{
    width: 53px;
    height: 30px;
    background: #faefbf;
    border-radius: 6px 6px 6px 6px;
    border: 2px solid #FFFFFF;
    text-align: center;
    line-height: 28px;
    box-sizing: border-box;
  }

  .active{
    background: #ffa632;
    color: #FFFFFF;
  }

  .mr-16{
    margin-right: 14px;
  }

  .work-card{
    width: 100%;
    padding: 16px 24px;
    background-image: url("https://appfile2.sbgw.cn/hhsbzhxt/1f0c811bdfac4bd88ad31acbc3ea5e96.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-bottom: 8px;
    height: 38.7vh;
  }

  .attendance-left {
    width: 50%;
    min-height: 190px;
  }

  .mr-15{
    margin-right: 15px;
  }

  .mr-5{
    margin-right: 5px;
  }

  .attendance-right {
    width: 50%;
    min-height: 190px;
  }

  .table-title {
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 600;
  }

  .table-content {
    .table-header {
      padding: 0 16px;
      box-sizing: border-box;
      height: 3vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      background-color: #f5f4f0;
    }

    .table-header1{
      padding: 0 16px;
      box-sizing: border-box;
      height: 3vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      background-color: #f5f4f0;
    }

    .columns-style {
      background-color: #f5f4f0;
    }

    .table-row {
      height: 3vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding: 0 16px;
      box-sizing: border-box;
    }

    .table-row1{
      height: 3vh;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 16px;
    }

    .rank-column {
      width: 30px;
      text-align: right;
    }

    .class-column {
      flex: 1;
      padding: 0 16px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
    .class-column1 {
      flex: 1;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    .rate-column,
    .count-column {
      width: 60px;
      text-align: right;
    }

    .count-column1{
      width: 108px;
      text-align: right;
    }

    .score-column {
      width: 48px;
      text-align: right;
    }

    .number-of-excess-column {
      text-align: right;
      width: 75px;
    }

    .attendance-rate-column {
      text-align: right;
      width: 50px;
    }
  }
}

.integral-content {
  margin-top: -16px;
  .chart-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    display: block;
  }

  .chart-container {
    width: 100%;
  }

  .pie-chart {
    display: flex;
    flex-direction: column;
    align-items: center;

    .chart-container {
      height: 170px;
    }
  }

  .trend-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;

    .chart-container {
      height: 13.4vh;
    }
  }

  .class-points {
    margin-top: 16px;

    > span {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      display: block;
      margin-bottom: 12px;
    }

    .table-content {
      background: #f8f8f8;
      border-radius: 4px;
      padding: 8px 0px;
    }

    > div {
      display: flex;
      justify-content: space-between;
      gap: 16px;

      .class-points-left {
        width: 48%;

        span {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: block;
        }
      }

      .class-points-right {
        width: 54%;
        margin-left: -5px;

        span {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          display: block;
        }
      }
    }

    .chart-container {
      margin-top: 3.5vh;
      width: 100%;
      height: 11.4vh;
      background: #f8f8f8;
      border-radius: 4px;
    }
  }
}

.homework-submit-data {
  margin-top: -16px;
  min-height: 273px;
}

.word-learning-content {
  margin-top: -16px;

  .word-learning-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .word-learning-rankings {
      width: 60%;
      min-height: 191px;
    }

    .word-learning-trend {
      width: 50%;

      .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
        display: block;
      }

      .chart-container {
        width: 100%;
        height: 126px;
        margin-top: 16px;
      }
    }
  }

  .word-learning-bottom {
    width: 100%;
    min-height: 191px;
  }

  .rank-section {
    .section-title {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
      display: block;
    }
  }
}

.carousel-container {
  position: relative;
}

:deep(.el-carousel__container) {
  height: 100%;
}

.table-title-container {
  height: 2.5vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;

  .carousel-indicators {
    display: flex;
    gap: 4px;

    .indicator {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #e5e5e5;
      cursor: pointer;
      // transition: all 0.3s;

      &.active {
        background: #ffa632;
      }

      &:hover {
        background: #ffa632;
      }
    }
  }
}

.table-title {
  font-size: 14px;
  font-weight: 600;
}

.title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}


.title-text{
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 14px;
  margin-top: 5px;
  /* 多行省略号样式 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-right: 26px;
}

.table-row {
  display: flex;
  justify-content: space-between;
}

.echarts-tooltip-custom {
  width: 180px;
  height: 72px;
  background: black;
  border-radius: 6px 6px 6px 6px;
  margin: 8px;
}

.tooltip-title {
  color: #333;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
}

.echarts-tooltip-custom .tooltip-value {
  color: #ffa632;
  font-weight: bold;
  padding-left: 4px;
}

.calss-title {
  width: 100%;
  font-size: 12px !important;
}

:deep(.el-progress-bar__outer),
:deep(.el-progress-bar__inner) {
  border-radius: 0;
}

.nodata{
  margin-left: 40%;
  color: #bbb;
  font-size: 15px;
  font-weight: 600;
}

.attendance-card{
  margin-bottom: 8px;
  background-size: 100% 100% !important;
}
</style>
